import { useState } from 'react'

import type { MessageType } from '@skytech/ui'
import { MessagePopup } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'

import appQueries from '@/app/queries'
import appResources from '@/app/resources'
import { useTranslation } from '@/app/translations/hooks'
import type { InjuryReportForm, OffboardingForm, OnboardingForm } from '@/app/types'

export const useOnboardingForm = () => {
  const { data, refetch } = useQuery(appQueries.form(), appResources.getForm)
  const formData = data as OnboardingForm

  return { data: formData, refetch }
}

export const useOffBoardingForm = () => {
  const { data, refetch } = useQuery(appQueries.form(), appResources.getForm)
  const formData = data as OffboardingForm

  return { data: formData, refetch }
}

export const useInjuryReportForm = () => {
  const { data, refetch } = useQuery(appQueries.form(), appResources.getForm)
  const formData = data as InjuryReportForm

  return { data: formData, refetch }
}

export const useSubmitFormMessage = () => {
  const translate = useTranslation()
  const [messageModal, setMessageModal] = useState<{
    type: MessageType | null
    message: string
    title: string
  }>({
    type: null,
    message: '',
    title: '',
  })

  return {
    onSubmitFormSuccess: () =>
      setMessageModal({
        type: 'success',
        message: translate('Form submitted!'),
        title: translate('Form upload success'),
      }),
    onSubmitFormError: () =>
      setMessageModal({
        type: 'error',
        message: translate('Could not load form!'),
        title: translate('Form upload error'),
      }),
    SubmitFormMessagePopup: () => (
      <MessagePopup
        type={messageModal.type || undefined}
        title={messageModal.title}
        message={messageModal.message}
        isOpen={Boolean(messageModal.type)}
        onClose={() => setMessageModal({ type: null, message: '', title: '' })}
      />
    ),
  }
}
